export const ANP_LPC_LISTING_URL =
  'https://www.gov.br/anp/pt-br/assuntos/precos-e-defesa-da-concorrencia/precos/levantamento-de-precos-de-combustiveis-ultimas-semanas-pesquisadas';

export const ANP_MIN_PRECOS_MEDIOS = 2_000;
export const ANP_MAX_PRECOS_MEDIOS = 3_500;
export const ANP_MIN_MUNICIPIOS = 350;
export const ANP_MAX_MUNICIPIOS = 450;
export const ANP_PRODUTO_COUNT = 7;
export const ANP_UF_COUNT = 27;

export const ANP_GOLDEN_WEEK_INICIO = '2026-06-14';
export const ANP_GOLDEN_WEEK_FIM = '2026-06-20';
